import { render, staticRenderFns } from "./afterSaleList.vue?vue&type=template&id=15bff83e&scoped=true&"
import script from "./afterSaleList.vue?vue&type=script&lang=js&"
export * from "./afterSaleList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./afterSaleList.vue?vue&type=style&index=1&id=15bff83e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bff83e",
  null
  
)

component.options.__file = "afterSaleList.vue"
export default component.exports